export default {
    general: {
        name: 'Kalamaio',
        welcome: 'Welcome to Kalamaio VIP',
        description: 'We are building a new way to communicate.'
    },
    messages: {
        discovermoreon: 'Discover more on'
    }
};
